/**
 * @param blob the data to download as a file
 * @param name the name of the file, make sure to include the extension (i.e. `name.csv`)
 */
export function downloadFile(blob: Blob, name: string) {
	const url = URL.createObjectURL(blob);

	const anchor = document.createElement('a');
	anchor.href = url;
	anchor.download = name;
	anchor.click();

	setTimeout(() => {
		URL.revokeObjectURL(url);
		anchor.remove();
	}, 0);
}

/**
 * @param base64 the full base64 string to download as a file
 * @param name the name of the file, make sure to include the extension (i.e. `name.csv`)
 */
export function downloadBase64(base64: string, name: string) {
	const anchor = document.createElement('a');
	anchor.href = base64;
	anchor.download = name;
	anchor.click();

	setTimeout(() => {
		anchor.remove();
	}, 0);
}
